import { backofficeRequest } from '../../../axios'
import axios from 'axios'
import config from '../../../config'

export const sendLetterApi = async (formData) => {
  try {
    return await axios({
      method: 'post',
      url: `${config.BASE_URL_V2}/backoffice/letters`,
      data: formData,
      headers: {
        auth_token: config.auth_token,
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    return error
  }
}

export const getCondoListApi = async () => {
  try {
    const response = await backofficeRequest.get('backoffice/condominiums')
    return response.data
  } catch (error) {
    return error
  }
}
